export const stateToComponentMap = {
  merged: 'mr-widget-merged',
  closed: 'mr-widget-closed',
  merging: 'mr-widget-merging',
  conflicts: 'mr-widget-conflicts',
  missingBranch: 'mr-widget-missing-branch',
  draft: 'mr-widget-wip',
  readyToMerge: 'mr-widget-ready-to-merge',
  nothingToMerge: 'mr-widget-nothing-to-merge',
  notAllowedToMerge: 'mr-widget-not-allowed',
  archived: 'mr-widget-archived',
  checking: 'mr-widget-checking',
  preparing: 'mr-widget-preparing',
  unresolvedDiscussions: 'mr-widget-unresolved-discussions',
  pipelineBlocked: 'mr-widget-pipeline-blocked',
  pipelineFailed: 'mr-widget-pipeline-failed',
  autoMergeEnabled: 'mr-widget-auto-merge-enabled',
  failedToMerge: 'mr-widget-failed-to-merge',
  autoMergeFailed: 'mr-widget-auto-merge-failed',
  shaMismatch: 'sha-mismatch',
  rebase: 'mr-widget-rebase',
  mergeChecksFailed: 'mergeChecksFailed',
};

export const statesToShowHelpWidget = [
  'merging',
  'conflicts',
  'draft',
  'readyToMerge',
  'checking',
  'unresolvedDiscussions',
  'pipelineFailed',
  'pipelineBlocked',
  'autoMergeFailed',
  'rebase',
];

export const stateKey = {
  archived: 'archived',
  missingBranch: 'missingBranch',
  nothingToMerge: 'nothingToMerge',
  preparing: 'preparing',
  checking: 'checking',
  conflicts: 'conflicts',
  draft: 'draft',
  pipelineFailed: 'pipelineFailed',
  unresolvedDiscussions: 'unresolvedDiscussions',
  pipelineBlocked: 'pipelineBlocked',
  shaMismatch: 'shaMismatch',
  autoMergeFailed: 'autoMergeFailed',
  autoMergeEnabled: 'autoMergeEnabled',
  notAllowedToMerge: 'notAllowedToMerge',
  readyToMerge: 'readyToMerge',
  rebase: 'rebase',
  merging: 'merging',
  merged: 'merged',
  mergeChecksFailed: 'mergeChecksFailed',
};
